module.exports = __webpack_public_path__ + "static/media/cup.bccb6162.svg";